import EDPIcon from 'components/Content/Happening/HappeningEDP/EDPReservationPolicies/EDPIcon/EDPIcon';

export default EDPIcon;
